export const hr = {
    "public-invitation-title": "Pozivnica za događaj",
    "public-invitation-loading": "Provjeravamo pozivnicu",
    "public-invitation-status": "Status",
    "public-invitation-participant": "Sudionik",
    "public-invitation-company": "Tvrtka",
    "public-invitation-dates": "Datumi",
    "public-invitation-location": "Mjesto",
    "public-invitation-on-site-instructions": "Upute za registraciju na lokaciji",
    "public-invitation-status-submitted": "Prijavljen",
    "public-invitation-status-rejected": "Odbijen",
    "public-invitation-status-invited": "Pozvan",
    "public-invitation-status-registered": "Registriran",
    "public-invitation-status-confirmed": "Potvrđen",
    "public-invitation-help": "Pokažite QR kod iz e-maila na registracijskom pultu. Otvaranje ove stranice ne mijenja status vaše prijave.",
    "public-registration-details-title": "Detalji prijave",
    "public-registration-details-help": "QR pozivnicu dobit ćete e-poštom kad vas organizator pozove; pokažite je na registracijskom pultu. Otvaranje ove stranice ne mijenja status vaše prijave.",
    "public-invitation-invalid": "Ova poveznica pozivnice nije ispravna ili više nije aktivna.",
    "public-invitation-unavailable": "Trenutačno nije moguće provjeriti pozivnicu.",
    "public-invitation-error-help": "Provjerite jeste li otvorili cijelu poveznicu iz e-maila ili se obratite organizatoru događaja.",
    "event-workspace.payments": "Plaćanja",
    "event-payments.search": "Pretraži ponudu, sudionika ili platitelja",
    "event-payments.filter": "Filtar ponuda",
    "event-payments.filter-current": "Važeće ponude",
    "event-payments.filter-outstanding": "Neplaćeno",
    "event-payments.filter-paid": "Plaćeno",
    "event-payments.filter-all": "Sve, uključujući zamijenjene",
    "event-payments.offer": "Ponuda",
    "event-payments.participant": "Sudionik",
    "event-payments.payer": "Platitelj",
    "event-payments.type": "Vrsta",
    "event-payments.status": "Status ponude",
    "event-payments.amount": "Iznos",
    "event-payments.paid": "Plaćeno",
    "event-payments.outstanding": "Preostalo",
    "event-payments.due-date": "Dospijeće",
    "event-payments.actions": "Radnje",
    "event-payments.balance-paid": "Plaćeno",
    "event-payments.balance-partial": "Djelomično plaćeno",
    "event-payments.balance-unpaid": "Neplaćeno",
    "event-payments.overdue": "Dospjelo",
    "event-payments.open-payer": "Otvori platitelja",
    "event-payments.empty": "Za ovaj događaj još nema ponuda",
    "event-payments.load-failed": "Ponude i plaćanja nije moguće učitati.",
    "payment-entry-title": "Evidentiraj uplatu",
    "payment-entry-help": "Evidentirajte stvarno primljenu uplatu. Iznos se povezuje s odabranom ponudom i označava kao ručno usklađen. Djelomične uplate su dopuštene; iznos ne može premašiti preostalo dugovanje.",
    "payment-entry-offer": "Ponuda",
    "payment-entry-offer-total": "Ukupan iznos ponude",
    "payment-entry-amount": "Primljeni iznos",
    "payment-entry-date": "Datum uplate",
    "payment-entry-method": "Način uplate",
    "payment-entry-bank": "Bankovna uplata",
    "payment-entry-cash": "Gotovina",
    "payment-entry-sponsor": "Sponzor",
    "payment-entry-reference": "Poziv na broj / referenca",
    "payment-entry-note": "Napomena / osnova potvrde",
    "payment-entry-save": "Spremi uplatu",
    "payment-entry-close": "Zatvori",
    "payment-entry-required": "Obavezno polje.",
    "payment-entry-positive": "Upišite iznos veći od nule.",
    "payment-entry-no-offers": "Nema dostupnih važećih ponuda s iznosom za ovog platitelja.",
    "payment-entry-failed": "Uplatu nije moguće spremiti.",
    "payment-entry-refresh-failed": "Uplata je spremljena, ali osvježavanje popisa nije uspjelo. Zatvorite prozor i osvježite stranicu. Nemojte ponovno unositi ovu uplatu.",

    "hotels": "Hoteli",
    "hotels-description": "Globalni popis hotela",
    "hotels-field-name": "Naziv",
    "hotels-field-category": "Kategorija",
    "hotels-category-select": "Odaberite kategoriju hotela",
    "hotels-category-stars": "Kategorija hotela: {{count}} od 5 zvjezdica",
    "hotels-category-not-selected": "Nije odabrano",
    "hotels-field-address": "Adresa",
    "hotels-field-city": "Grad",
    "hotels-field-country": "Država",
    "hotels-field-notes": "Napomene",
    "hotels-search": "Pretraži po nazivu, gradu ili državi",
    "hotels-new": "Novi hotel",
    "hotels-save": "Spremi",
    "hotels-delete": "Obriši",
    "hotels-cancel": "Odustani",
    "hotels-saved": "Hotel je spremljen.",
    "hotels-save-failed": "Hotel nije moguće spremiti.",
    "hotels-delete-failed": "Hotel nije moguće obrisati.",
    "hotels-deleted": "Hotel je obrisan.",
    "hotels-delete-confirm": "Obrisati ovaj hotel iz globalnog popisa?",
    "hotels-in-use": "Hotel je povezan s događajem i nije ga moguće obrisati. Najprije uklonite poveznice u postavkama događaja.",
    "hotels-shared-info": "Promjene podataka hotela vrijede za sve događaje koji koriste ovaj hotel.",
    "hotels-name-required": "Upišite naziv hotela.",
    "hotels-not-found": "Hotel nije pronađen.",
    "hotels-retry": "Pokušaj ponovno",
    "event-config-delete-accommodation-options-reservations-warning": "Rezervacije su povezane sa sljedećim smještajnim opcijama: {{options}}. Brisanjem smještajnih opcija obrisat će se i povezane rezervacije.",

    "Allotment end date must be after start date.": "Završni datum smještaja mora biti nakon početnog datuma.",
    "Payment deadline must be on or before the allotment end date.": "Rok plaćanja mora biti na dan završetka smještaja ili ranije.",
    "Payment deadline must be on or before the event end date.": "Rok plaćanja mora biti na dan završetka događaja ili ranije.",
    "Total rooms must be greater than zero.": "Broj soba mora biti veći od nule.",
    "Room type name is required.": "Naziv tipa sobe je obvezan.",
    "Room capacity must be a whole number greater than zero.": "Kapacitet sobe mora biti cijeli broj veći od nule.",
    "Price must be zero or greater.": "Cijena mora biti nula ili veća.",
    "Select exactly one hotel.": "Odaberite jedan hotel.",
    "Hotel not found.": "Hotel nije pronađen.",
    "Hotel identity not found.": "Hotel nije pronađen u katalogu.",
    "Room type does not belong to the selected hotel.": "Tip sobe ne pripada odabranom hotelu.",
    "Room allotment not found.": "Razdoblje smještaja nije pronađeno.",
    "login": "Prijava",
    "register": "Registracija",
    "username": "Korisničko ime",
    "password": "Lozinka",
    "email": "Email",
    "go-back": "Nazad",
    "EmailConfirmed_PleaseWait": "Email je potvrđen. Molimo pričekajte...",
    "EmailConfirmationErrorPage_Title": "Greška kod potvrde emaila",
    "EmailConfirmationErrorPage_Text": "Došlo je do greške kod potvrde emaila. Molimo pokušajte ponovno.",
    "EmailConfirmed_Success": "Email je uspješno potvrđen.",
    "The Username field is required.": "Korisničko ime je obavezno.",
    "The Email field is required.": "Email je obavezan.",
    "The Password field is required.": "Lozinka je obavezna.",
    "EmailConfirmationErrorPage_BackButton": "Nazad",
    "redirector.unknownRoleForUsingApp": "Nemate još dodjeljen pristup aplikaciji.",
    "NotFoundPage_Title": "Stranica nije pronađena",
    "NotFoundPage_BackButton": "Nazad",
    "NotFoundPage_Text": "Stranica koju tražite nije pronađena.",
    "ConfirmYourEmail": "Na vaš email je poslan link za potvrdu. Molimo potvrdite svoj email.",
    "User email not confirmed": "Email nije potvrđen",
    "EmailNotConfirmed": "Email nije potvrđen",
    "ResendConfirmationEmail": "Ponovno pošalji link za potvrdu",
    "ResendConfirmationEmail_Success": "Link za potvrdu je uspješno poslan.",
    "PasswordTooShort": "Lozinka je prekratka.",
    "User not found": "Korisnik nije pronađen.",
    "back": "Nazad",
    "home": "Početna",
    "logout": "Odjava",
    "users": "Korisnici",
    "users-description": "Pregled korisnika",
    "organization-members": "Članovi organizacije",
    "organization-members-description": "Upravljanje organizatorskim računima",
    "organization-member": "Član organizacije",
    "add-organization-member": "Dodaj člana",
    "resend-onboarding": "Ponovno pošalji onboarding",
    "pending-onboarding": "Čekanje",
    "organization-member-created": "Član organizacije je kreiran",
    "organization-member-onboarding-sent": "Onboarding email je poslan",
    "organization-member-onboarding-invalid": "Ova onboarding poveznica nije ispravna ili je istekla.",
    "organization-member-onboarding-invalid-title": "Onboarding poveznica se ne može koristiti",
    "organization-member-onboarding-title": "Postavljanje organizatorskog računa",
    "organization-member-onboarding-help": "Odaberite lozinku za potvrdu pozivnice.",
    "organization-member-onboarding-submit": "Postavi lozinku",
    "administrator-only-page": "Ova stranica je dostupna samo administratorima.",
    "administration": "Administracija",
    "error-loading-items": "Greška kod učitavanja stavki",
    "search": "Pretraživanje",
    "change-type": "Vrsta promjene",
    "created-by": "Kreirao",
    "created-between": "Vrijeme kreiranja",
    "state": "Stanje",
    "created": "Kreirano",
    "changes": "Promjene",
    "Previous": "Prethodna",
    "Next": "Sljedeća",
    "create": "Dodaj",
    "cancel": "Odustani",
    "save": "Spremi",
    "id": "Ključ",
    "emailConfirmed": "Email potvrđen",
    "are-you-sure-you-want-to-delete-this-item": "Jeste li sigurni da želite obrisati ovu stavku?",
    "delete-confirmation-title": "Potvrda brisanja",
    "delete-confirmation-named-target": "Briše se {{itemType}} \"{{itemName}}\".",
    "delete-confirmation-count-target": "Broj odabranih zapisa za brisanje ({{itemType}}): {{count}}.",
    "delete-confirmation-target": "Briše se {{itemType}}.",
    "delete-confirmation-question": "Jeste li sigurni da želite obrisati?",
    "delete-target-record": "zapis",
    "delete-target-participant": "sudionik",
    "delete-target-payer": "platitelj",
    "delete-target-hotel": "hotel",
    "delete-target-invitation": "pozivnica na čekanju",
    "delete-target-template-field": "polje predloška",
    "delete-target-file": "datoteka",
    "delete-target-accommodation-option": "smještajna opcija",
    "delete-target-event-access": "pristup događaju",
    "delete": "Obriši",
    "page": "Strana",
    "InvalidEmail": "Upišite ispravan email",
    "additional": "Dodatno",
    "resendConfirmationEmail": "Ponovno pošalji link za potvrdu emaila",
    "no-items": "Nema stavaka",
    "status": "Status",
    "date": "Datum",
    "roles": "Uloge",
    "Admin": "Administrator",
    "Customer": "Korisnik",
    "taxId": "OIB",
    "actions": "Akcije",
    "locations": "Lokacije",
    "address": "Adresa",
    "location-name": "Naziv lokacije",
    "geodecode-address": "Potraži adresu na mapi",
    "import-locations": "Uvezi lokacije",
    "adding-users": "Dodavanje korisnika",
    "notification": "Obavijest",
    "successfully-deleted-item": "Uspješno obrisana stavka",
    "successfully-deleted-item-with-id": "Uspješno obrisana stavka sa šifrom",
    "error-deleting-item-with-id": "Greška kod brisanja stavke sa šifrom",
    "successfully-duplicated-item-with-id": "Uspješno duplicirana stavka sa šifrom",
    "error-duplicating-item-with-id": "Greška kod dupliciranja stavke sa šifrom",
    "company": "Tvrtka",
    "linkedin-url": "LinkedIn URL",
    "InvalidUserName": "Upišite ispravno korisničko ime",
    "editing-users": "Uređivanje korisnika",
    "edit": "Uredi",
    "show-only-unassigned": "Prikaži samo nedodijeljene",
    "settings": "Postavke",
    "global-settings": "Postavke",
    "start-search": "Pokreni pretraživanje",
    "isMainLocation": "Glavna lokacija",
    "assign": "Dodijeli",
    "assigned-user": "Dodijeljeno korisniku",
    "details": "Detalji",
    "user": "Korisnik",
    "user-overview": "Pregled korisnika",
    "MANAGER": "Upravitelj",
    "user-details": "Detalji korisnika",
    "confirmationEmailSent": "Email za potvrdu je poslan",
    "userName": "Korisničko ime",
    "firstName": "Ime",
    "lastName": "Prezime",
    "system": "Sustav",
    "basic-data": "Osnovni podaci",
    "role": "Uloga",
    "languages-full:hr": "Hrvatski",
    "languages-full:en": "Engleski",
    "languages-full:de": "Njemački",
    "languages-full:it": "Talijanski",
    "duplicate": "Dupliciraj",
    "name": "Naziv",
    "name-hr": "Naziv (hrvatski)",
    "name-en": "Naziv (engleski)",
    "place": "Mjesto",
    "description": "Opis",
    "event-information": "Informacije o događaju",
    "event-information-hr": "Informacije o događaju (hrvatski)",
    "event-information-en": "Informacije o događaju (engleski)",
    "on-site-registration-instructions": "Upute za registraciju na lokaciji",
    "on-site-registration-instructions-hr": "Upute za registraciju na lokaciji (hrvatski)",
    "on-site-registration-instructions-en": "Upute za registraciju na lokaciji (engleski)",
    "nameAndDescription": "Naziv i opis",
    "NoResults": "Nema rezultata",
    "dateTime": "Datum i vrijeme",
    "initiatingUser": "Inicijator",
    "deactivated": "Deaktivirano",
    "parent": "Nadređena",
    "parentId": "Nadređena",
    "Email already exists": "Email već postoji",
    "unassigned": "Nedodijeljeno",
    "note": "Napomena",
    "first-page": "Prva stranica",
    "next-page": "Sljedeća stranica",
    "previous-page": "Prethodna stranica",
    "last-page": "Zadnja stranica",
    "yes": "Da",
    "no": "Ne",
    "warning": "Upozorenje",
    "phoneNumber": "Broj telefona",
    "preferredLanguage": "Preferirani jezik",
    "quantity": "Količina",
    "add-row": "Dodaj redak",
    "header": "Zaglavlje",
    "basics": "Osnovno",
    "priority": "Prioritet",
    "BackGoToLogin": "Nazad na prijavu",
    "close": "Zatvori",
    "notes": "Napomene",
    "createdAt": "Datum i vrijeme kreiranja",
    "Only managers or field workers can set status to this value!": "Samo upravitelji ili terenski radnici mogu postaviti status na ovu vrijednost!",
    "Only field workers can set status to this value!": "Samo terenski radnici mogu postaviti status na ovu vrijednost!",
    "error-occurred": "Došlo je do greške",
    "reload": "Ponovno učitaj",
    "user-updated-successfully": "Korisnik je uspješno ažuriran",
    "profile-updated": "Profil je ažuriran",
    "profile": "Profil",
    "developer-feedback-title": "Prijavi grešku",
    "developer-feedback-help": "Opišite što se dogodilo. Uz prijavu šaljemo vaše ime i e-mail razvojnome timu.",
    "developer-feedback-description": "Opis greške",
    "developer-feedback-placeholder": "Što ste pokušali napraviti i što se dogodilo?",
    "developer-feedback-send": "Pošalji prijavu",
    "developer-feedback-queued": "Prijava je zaprimljena i čeka slanje.",
    "developer-feedback-error": "Prijavu trenutačno nije moguće poslati. Pokušajte ponovno.",
    "about-app-title": "O aplikaciji",
    "app-shell.open-menu": "Otvori izbornik",
    "app-shell.close-menu": "Zatvori izbornik",
    "app-shell.home": "ATIventura - početna",
    "app-shell.main-navigation": "Glavni izbornik",
    "app-shell.breadcrumb": "Putanja",
    "app-shell.language": "Jezik",
    "app-shell.account-menu": "Korisnički izbornik",
    "about-app-description": "EventFlow pomaže organizatorima u pripremi događaja, prijavama sudionika i radu na lokaciji.",
    "about-app-version": "Verzija",
    "about-app-changelog": "Što je novo",
    "about-app-error": "Podaci o verziji trenutačno nisu dostupni.",
    "profile-error": "Profil trenutno nije dostupan.",
    "profile-load-error-title": "Profil nije dostupan",
    "profile-save-success": "Profil je spremljen.",
    "save-profile": "Spremi profil",
    "email-signature": "Email potpis",
    "location": "Lokacija",
    "requested-by": "Traženo od",
    "startDate": "Početni datum",
    "endDate": "Završni datum",
    "count": "Broj",
    "xlsx_export": "Izvoz u Excel",
    "csv_export": "Izvoz u CSV",
    "current-page": "Stranica",
    "page-of": "od",
    "value": "Vrijednost",
    "Login": "Prijava",

    "dactivated": "Deaktivirano",
    "active": "Aktivno",
    "dateFrom": "Datum od",
    "dateTo": "Datum do",
    "enums:COMPLETED": "Odrađeno",
    "enums:CANCELLED": "Otkazano",
    "PasswordRequiresNonAlphanumeric": "Lozinka mora sadržavati barem jedan znak koji nije slovo ili broj",
    "signed": "Potpis",
    "scheduledAndFinishedDate": "Zakazano\nIzvršeno",
    "change-password": "Promjena lozinke",
    "oldPassword": "Stara lozinka",
    "newPassword": "Nova lozinka",
    "password-changed": "Lozinka je promijenjena",
    "emailAndPhone": "Email i telefon",
    "managers": "Upravitelji",
    "code": "Šifra",
    "password-reset": "Reset lozinke",
    "password-reset-successful": "Lozinka je uspješno resetirana",
    "No results": "Nema rezultata",
    "send-to": "Pošalji na",
    "open": "Otvori",
    "vat_base": "Osnovica PDV-a",
    "vat": "PDV",
    "total": "Ukupno",
    "attachments": "Prilozi",
    "fileName": "Naziv datoteke",
    "fileType": "Vrsta datoteke",
    "contentType": "Vrsta sadržaja",
    "preview": "Pregled",
    "Download": "Preuzmi",
    "vat-types": "Vrste PDV-a",
    "financial-accounts": "Konta",
    "adding-vatTypes": "Dodavanje vrste PDV-a",
    "editing-vatTypes": "Uređivanje vrste PDV-a",
    "rate": "Stopa",
    "adding-financialAccounts": "Dodavanje konta",
    "editing-financialAccounts": "Uređivanje konta",
    "number": "Broj",
    "externalId": "Vanjski ID",
    "vatTypeId": "Vrsta PDV-a",
    "vatType": "Vrsta PDV-a",
    "financialAccountId": "Konto",
    "financialAccount": "Konto",
    "isDeleted": "Obrisano",
    "restore": "Vrati",
    "no-data": "Nema podataka",
    "currentStatusId": "Status",
    "currentStatusStatus": "Status",
    "price": "Cijena",
    "isDefault": "Zadano",
    "price/vatBase": "Cijena / osnovica",
    "xls_export": "Izvoz u Excel",
    "mark-as-invoiced": "Označi kao fakturirano",
    "item-order-restored": "Usluga ili materijal je vraćen",
    "Item not found": "Usluga ili materijal nije pronađen",
    "Item is not deleted": "Usluga ili materijal nije obrisana",
    "vatRate/vat": "Stopa PDV / PDV",
    "confirmManually": "Potvrdi ručno",
    "itemUnitPrice": "Cijena",
    "prints": "Ispisi",
    "calculationDate": "Datum obračuna",
    "The current user is not authorized to access this resource.": "Trenutni korisnik nije ovlašten za pristup ovom resursu.",
    "only-signed": "Samo potpisani",
    "only-unsigned": "Samo nepotpisani",
    "show-all": "Prikaži sve",
    "only-deleted": "Samo obrisani",
    "only-active": "Samo aktivni",
    "only-deactivated": "Samo deaktivirani",
    "enter-reason-for-cancellation": "Unesite razlog za otkazivanje",
    "clear-filter": "Očisti filter",
    "startDateFrom": "Datum početka od",
    "startDateTo": "Datum početka do",
    "endDateFrom": "Datum izvršenja od",
    "endDateTo": "Datum izvršenja do",
    "bulkInvoicing": "Zbirno fakturiranje",
    "bulkInvoicingDay": "Dan zbirnog fakturiranja",
    "bulkInvoicingDayOfMonth": "Dan zbirnog fakturiranja u mjesecu",
    "last_day_of_month": "Zadnjeg dana u mjesecu",
    "bulk_invoicing": "Zbirno fakturiranje",
    "lastPushAttemptAt": "Zadnji pokušaj slanja",
    "lastPushError": "Zadnja greška slanja",
    "item_missing_external_id": "Usluga ili materijal '{{item[x]}}' nema vanjski ID",
    "unit_missing_external_id": "Jedinica mjere '{{unit[x]}}' nema vanjski ID",
    "field": "Polje",
    "message": "Poruka",
    "successfully-saved-item": "Stavka je uspješno spremljena",
    "events-and-forms": "Događaji i prijavni obrasci",
    "attendees-and-registrations": "Sudionici i prijave",
    "finance": "Financije",
    "resources": "Resursi",
    "events": "Događaji",
    "events-description": "Kreirajte i upravljajte događajima.",
    "archive": "Arhiva",
    "archive-description": "Pregled arhiviranih događaja i operativne povijesti.",
    "payers": "Platitelji",
    "payers-description": "Pretražite i uredite globalni katalog platitelja.",
    "fee-type-public-hidden": "Sakriveno na javnom obrascu",
    "fee-type-requires-proof": "Traži dokaz",
    "participant-type-proof": "Dokaz o vrsti sudionika",
    "participant-delete-confirm": "Obrisati sudionika?",
    "participant-delete-confirm-description": "Sudionik {{participant}} bit će uklonjen iz događaja.",
    "participant-delete-success": "Sudionik je obrisan.",
    "participant-delete-failed": "Sudionika nije bilo moguće obrisati.",
    "participant-register-missing-payer": "Platitelj",
    "participant-register-active-form-required": "Prije prijave sudionika izradite i aktivirajte javni prijavni obrazac u kartici Obrazac događaja.",
    "open-payer": "Otvori platitelja",
    "new-payer": "Novi platitelj",
    "save-registration": "Spremi prijavu",
    "select-payer": "Odaberi platitelja",
    "select-payer-placeholder": "Pretraži po nazivu, emailu ili OIB-u",
    "event-config": "Postavke događaja",
    "event-config-description": "Postavite brending, poreze, cijene, opcije, hotele i email tekstove za sudionike.",
    "registration-forms": "Javna prijava",
    "registration-forms-description": "Podijelite živi javni URL za prijavu na događaj.",
    "accommodations": "Smještaji",
    "accommodations-description": "Upravljajte smještajnim opcijama vezanim uz događaje.",
    "room-allotments": "Alokacije soba",
    "room-allotments-description": "Dodijelite blokove soba i pratite dostupnost po noćenjima.",
    "participants": "Sudionici",
    "participants-description": "Pregledajte i upravljajte ljudima koji prisustvuju događajima.",
    "registrations": "Prijave",
    "registrations-description": "Pregledajte prijave sudionika, statuse i dodijeljene smještaje.",
    "notifications": "Obavijesti",
    "notifications-description": "Pošaljite obavijesti za događaj i pregledajte povijest isporuke.",
    "general-settings": "Postavke organizacije",
    "general-settings-description": "Upravljajte primateljem plaćanja i zadanim poreznim postavkama.",
    "public-event-forms": "Dijeljenje žive prijave",
    "public-event-forms-description": "Podijelite hostirani javni URL za prijavu i iframe. Promjene iz postavljanja odmah su vidljive.",
    "public-event-forms.explainer-title": "Što javni obrazac koristi",
    "public-event-forms.explainer-active": "Hostirani URL uvijek koristi trenutno postavljanje događaja.",
    "public-event-forms.explainer-live-setup": "Cjenik, načini plaćanja, smještaj, raspoloživost soba, aktivnosti i javni tekst ostaju živi iz postavljanja.",
    "public-registration-share": "Dijeljenje javne prijave",
    "public-registration-share-description": "Koristite hostirani URL za običan WordPress link ili kopirajte iframe isječak za dopušteni embed.",
    "recipient-email": "Email primatelja",
    "sent-by": "Poslao",
    "sent-at": "Poslano",
    "failed-at": "Neuspjelo",
    "failure-message": "Poruka greške",
    "notification-history-count": "{{count}} zapisa obavijesti",
    "notifications-recipient-details-search": "Pretraži primatelje",
    "notifications-recipient-details-search-placeholder": "Pretraži po emailu, statusu ili isporuci",
    "notifications-recipient-details-search-count": "{{shown}} od {{total}} primatelja",
    "notifications-recipient-details-search-empty": "Nema primatelja koji odgovaraju pretrazi.",
    "notifications-save-recipient-selection": "Spremi odabir",
    "notifications-reply-to-enabled": "Želim Reply-To adresu",
    "notifications-reply-to-addresses": "Reply-To adrese",
    "notifications-reply-to-placeholder": "Upišite Reply-To adrese",
    "customer-purchase-order": "Narudžbenica kupca",
    "download-customer-purchase-order": "Preuzmi narudžbenicu",
    "customer-purchase-order-missing": "Nedostaje",
    "replace-customer-purchase-order": "Zamijeni narudžbenicu",
    "upload-customer-purchase-order": "Učitaj narudžbenicu",
    "customer-purchase-order-upload-success": "Narudžbenica kupca je spremljena.",
    "customer-purchase-order-upload-failed": "Narudžbenicu kupca nije bilo moguće spremiti.",
    "customer-purchase-order-download-failed": "Narudžbenicu kupca nije bilo moguće preuzeti.",
    "select-event-to-view-notifications": "Odaberite događaj za pregled povijesti obavijesti.",
    "notification-status:SENT": "Poslano",
    "notification-status:FAILED": "Neuspjelo",
    "notification-status:DRAFT": "Skica",
    "cta.new-event": "Novi događaj",
    "cta.view-schedule": "Pregledaj raspored",
    "cta.preview-form": "Pregled obrasca",
    "cta.new-accommodation": "Novi smještaj",
    "cta.manage-room-types": "Upravljanje tipovima soba",
    "cta.new-room-allotment": "Nova alokacija soba",
    "cta.adjust-allotment": "Prilagodi alokaciju",
    "cta.new-participant": "Dodaj sudionika",
    "cta.import-participants": "Uvezi sudionike",
    "cta.new-registration": "Dodaj prijavu",
    "cta.assign-accommodation": "Dodijeli smještaj",
    "cta.view-public-form": "Otvori javni obrazac",
    "cta.copy-public-link": "Kopiraj javni link",
    "cta.save": "Spremi",
    "cta.edit-definition": "Uredi definiciju",
    "start-date": "Početni datum",
    "end-date": "Završni datum",
    "capacity": "Kapacitet",
    "beds": "Kreveti",
    "rooms": "Sobe",
    "assigned": "Dodijeljeno",
    "remaining": "Preostalo",
    "total-rooms": "Ukupno soba",
    "version": "Verzija",
    "fields": "Polja",
    "event": "Događaj",
    "participant": "Sudionik",
    "group": "Grupa",
    "members": "Članovi",
    "balance": "Saldo",
    "payer": "Platitelj",
    "reference": "Poziv na broj",
    "payment": "Uplata",
    "target": "Cilj",
    "amount": "Iznos",
    "timestamp": "Vrijeme",
    "action": "Radnja",
    "entity": "Entitet",
    "linked-to": "Povezano s",
    "filters": "Filteri",
    "filter.event": "Događaj",
    "event-drilldown": "Kreni od događaja",
    "event-workspace.navigation": "Navigacija događaja",
    "event-workspace.group.setup": "Postavke",
    "event-workspace.group.operations": "Operativa",
    "event-workspace.overview": "Pregled",
    "event-workspace.group-operate": "Rad na događaju",
    "event-workspace.group-setup": "Priprema",
    "event-workspace.group-selector": "Područje radnog prostora događaja",
    "event-workspace.settings": "Osnovni podaci",
    "event-workspace.registration-fees": "Kotizacije i plaćanje",
    "event-workspace.accommodation": "Smještaj",
    "event-workspace.activities": "Aktivnosti",
    "event-workspace.registration-form": "Obrazac",
    "event-workspace.rooming": "Rezervacije",
    "event-workspace.audit": "Audit",
    "event-workspace.workspace": "Radni prostor događaja",
    "event-workspace.current-workflow": "Trenutni tijek rada",
    "event-workspace.current-group": "Trenutna grupa",
    "event-workspace.current-section": "Trenutna sekcija",
    "event-workspace.status-labels": "Statusi događaja",
    "event-workspace.form-linked": "Obrazac povezan",
    "event-workspace.form-needed": "Obrazac potreban",
    "event-workspace.active-group": "Aktivno",
    "event-overview.setup-pipeline": "Pregled postavljanja",
    "event-overview.setup-pipeline-description": "Provjerite slijed postavljanja: osnovno, kotizacije, smještaj, aktivnosti/dodaci i prijavni obrazac.",
    "event-overview.open-event-basics": "Otvori osnovno",
    "event-overview.trend-group-by": "Grupiraj po",
    "event-overview.trend-period": "Razdoblje",
    "event-overview.trend-days": "Dani",
    "event-overview.trend-weeks": "Tjedni",
    "event-overview.trend-months": "Mjeseci",
    "event-overview.trend-last-7-days": "Zadnjih 7 dana",
    "event-overview.trend-last-30-days": "Zadnjih 30 dana",
    "event-overview.trend-last-6-months": "Zadnjih 6 mjeseci",
    "setup-sequence.basic-title": "Osnovno o događaju",
    "setup-sequence.basic-description": "Postavite identitet događaja, datume, hrvatski i engleski javni sadržaj, vizuale/dokumente, porezne vrijednosti, načine plaćanja i email tekst prije dijeljenja obrasca.",
    "setup-sequence.pricing-title": "Kotizacije",
    "setup-sequence.pricing-description": "Oznaka ima li događaj kotizaciju i načini plaćanja ostaju u Postavkama. Ovdje uređujete cjenovna razdoblja, vrste kotizacija i cijene.",
    "setup-sequence.accommodation-title": "Smještaj",
    "setup-sequence.accommodation-description": "Opcionalno postavljanje hotela, tipova soba, alokacija, cijena i rokova plaćanja. Javna prijava troši zalihu soba događaja prije plaćanja.",
    "event-config-hotel-unavailable": "Hotel nije dostupan",
    "event-config-room-type-unavailable": "Tip sobe nije dostupan",
    "setup-sequence.activities-title": "Aktivnosti/dodaci",
    "setup-sequence.registration-title": "Prijavni obrazac",
    "has-participation-fee": "Ima kotizaciju",
    "cta.view-registrations": "Prijave",
    "cta.view-rooming": "Smještaj",
    "cta.view-forms": "Obrasci",
    "method": "Način",
    "paid-at": "Plaćeno u",
    "packageCode": "Paket",
    "upload-file": "Prenesi datoteku",
    "clear": "Očisti",
    "file-not-selected": "Datoteka nije odabrana",
    "file-uploaded": "Datoteka je prenesena",
    "logo-url": "Datoteka logotipa događaja",
    "program-pdf-url": "Datoteka programskog PDF-a",
    "venue-layout-image-url": "Datoteka slike plana prostora",
    "sponsors-image-url": "Datoteka slike sponzora",
    "primary-color": "Primarna boja",
    "secondary-color": "Sekundarna boja",
    "badge-template-url": "Datoteka vizuala akreditacije",
    "certificate-template-url": "Datoteka predloška potvrde",
    "certificate-name-x": "Položaj imena - vodoravni odmak",
    "certificate-name-y": "Položaj imena - okomiti odmak",
    "validation.color-required": "{{field}} je obavezna.",
    "validation.hex-color": "{{field}} mora biti HEX boja poput #223F6B.",
    "validation.field-required": "{{field}} je obavezno.",
    "validation.required-field": "Obvezno polje",
    "validation.number": "{{field}} mora biti broj.",
    "asset-mode-combined-pdf": "Jedan PDF",
    "asset-mode-separate-program-layout": "Program + mapa",
    "public-asset-mode": "Javni format priloga",
    "combined-program-layout-pdf-url": "PDF programa i plana prostora",
    "price-period-start-date-required": "Početni datum je obavezan.",
    "price-period-end-date-required": "Završni datum je obavezan.",
    "price-period-end-before-start": "Završni datum mora biti na ili nakon početnog datuma.",
    "price-period-overlap": "Cjenovna razdoblja se ne smiju preklapati. Ovaj raspon se preklapa s {{period}} ({{startDate}} - {{endDate}}).",
    "event-end-date-before-start": "Završni datum mora biti na ili nakon početnog datuma.",
    "event-access-card-title": "Pristup događaju",
    "event-access-user-placeholder": "Organizator",
    "event-access-grant": "Dodijeli pristup",
    "event-access-revoke": "Ukloni",
    "event-access-empty": "Nema suradnika",
    "event-access-granted": "Pristup događaju je dodijeljen",
    "event-access-revoked": "Pristup događaju je uklonjen",
    "privacy-consent-missing": "Nedostaje",
    "privacy-consent-recorded": "Zabilježeno",
    "privacy-consent-version": "Verzija",
    "privacy-consent-event-id": "ID događaja za privolu",
    "organizerName": "Organizator",
    "sponsorName": "Sponzor",
    "event-create-wizard.title": "Novi događaj",
    "event-create-wizard.basic-description": "Sada kreiraj osnovu događaja. Javni tekst, vizuale, cijene, smještaj i aktivnosti dovrši u radnom prostoru.",
    "event-create-wizard.event-name": "Naziv događaja",
    "event-create-wizard.place": "Grad / mjesto",
    "event-create-wizard.address": "Adresa lokacije",
    "event-create-wizard.end-date-after-start": "Završni datum mora biti na ili nakon početnog datuma.",
    "event-create-wizard.fee-choice": "Kotizacija",
    "event-create-wizard.fee-no": "Bez kotizacije",
    "event-create-wizard.fee-yes": "Ima kotizaciju",
    "event-create-wizard.no-fee-description": "Odabrano je bez kotizacije. Cjenik nije potreban za prvo spremanje.",
    "event-create-wizard.fee-description": "Odabrana je kotizacija. Razdoblja, tipove sudionika i cijene dodaj nakon kreiranja.",
    "event-create-wizard.create-and-open": "Kreiraj događaj",
    "event-create-wizard.created": "Događaj je kreiran",
    "event-create-wizard.missing-event-id": "Događaj je kreiran, ali novi radni prostor nije moguće prepoznati.",
    "ok": "U redu",
    "payer-save-success": "Platitelj je spremljen.",
    "payer-create-success": "Platitelj je dodan.",
    "payer-save-failed": "Platitelja nije bilo moguće spremiti.",
    "payer-delete-success": "Platitelj je obrisan.",
    "payer-delete-failed": "Platitelja nije bilo moguće obrisati.",
    "participant-and-event": "Sudionik / događaj",
    "payer-search-placeholder": "Pretraži po nazivu, emailu ili OIB-u",
    "payer-edit": "Uredi platitelja",
    "payer-create": "Dodaj platitelja",
    "all-payers": "Svi platitelji",
    "list-search": "Pretraživanje popisa",
    "check-in.token-url-invalid": "Skenirani URL ne sadrži token registracijskog koda.",
    "check-in.badge-download-missing": "Najprije skenirajte valjani kod.",
    "check-in.badge-download-failed": "Akreditaciju nije bilo moguće izraditi.",
    "check-in.badge-downloaded": "Akreditacija spremna za ispis je preuzeta.",
    "check-in.download-badge": "Preuzmi akreditaciju",
    "organization-member-created-email-failed": "Član organizacije je dodan, ali e-mail za uključivanje nije poslan. Provjerite SMTP postavke i ponovno pošaljite poziv.",
    "organization-member-onboarding-email-failed": "E-mail za uključivanje nije poslan. Provjerite SMTP postavke i ponovno pošaljite poziv.",
    "organization-member-updated": "Član organizacije je ažuriran",
    "organization-member-reactivate-confirm": "Ponovno aktivirati ovog člana organizacije?",
    "organization-member-deactivate-confirm": "Deaktivirati ovog člana organizacije?",
    "confirm": "Potvrdi",
    "organization-member-reactivated": "Član organizacije je ponovno aktiviran",
    "organization-member-deactivated": "Član organizacije je deaktiviran",
    "organization-member-invite-removed": "Poziv na čekanju je uklonjen",
    "organization-member-remove-invite": "Ukloni poziv",
    "deactivate": "Deaktiviraj",
    "reactivate": "Ponovno aktiviraj",
    "edit-organization-member": "Uredi člana",
    "participant-export-minimal-fields": "ID događaja, e-mail, status, plaćanje, potvrdnica",
    "rooming-export-minimal-fields": "Izvoz samo smještaja",
    "validation.complete-required-fields": "Provjerite obavezna polja i pokušajte ponovno.",
    "validation.correct-invalid-values": "Provjerite unesene vrijednosti i pokušajte ponovno.",
    "enums:QUEUED": "Na čekanju",
    "change-payer": "Promijeni platitelja",
    "participant-payer-chosen-at-registration": "Platitelj se odabire pri prijavi sudionika.",
    "participant-payer-locked": "Ovom platitelju već je izdana ponuda pa se platitelj ne može promijeniti.",
    "participant-payer-required": "Najprije odaberite platitelja.",
    "participant-payer-change-success": "Platitelj je promijenjen.",
    "participant-payer-change-failed": "Platitelja nije moguće promijeniti.",
    "organizer-registration.title": "Prijava sudionika",
    "organizer-registration.submit": "Prijavi",
    "organizer-registration.payer-mode-new": "Novi platitelj",
    "organizer-registration.payer-mode-existing": "Postojeći platitelj",
    "organizer-registration.payer-required": "Odaberite platitelja.",
    "organizer-registration.verification-note": "Sudionik će e-mailom dobiti poveznicu za potvrdu adrese. Ponuda se šalje nakon potvrde, kao i kod javne prijave.",
    "organizer-registration.success": "Sudionik je prijavljen. Poslan je e-mail za potvrdu adrese.",
    "organizer-registration.unavailable": "Prijava nije moguća: događaj je završen ili nema aktivan prijavni obrazac.",
    "organizer-registration.load-failed": "Prijavni obrazac nije moguće učitati.",
    "qr-email-not-confirmed": "Sudionik još nije potvrdio e-mail adresu",
    "enums:PRIJAVLJEN": "Prijavljen",
    "enums:ODBIJEN": "Odbijen",
    "enums:POZVAN": "Pozvan",
    "enums:REGISTRIRAN": "Registriran",
    "enums:POTVRDEN": "Potvrđen",
    "validation-required": "Obavezno polje",
    "validation-invalid-email": "Unesite ispravnu e-mail adresu.",
    "validation-invalid-phone": "Unesite ispravan broj telefona.",
    "validation-invalid-linkedin": "Unesite poveznicu na LinkedIn profil.",
    "event-config-delete-accommodation-options-none": "Odaberite barem jedan tip sobe za brisanje.",
    "template-event-data-unavailable": "Podaci događaja još nisu učitani pa se predložak ne može spremiti. Osvježite stranicu i pokušajte ponovno.",
    "notifications-send-reason-event": "Najprije otvorite događaj.",
    "notifications-send-reason-recipients": "Odaberite barem jednog primatelja.",
    "notifications-send-reason-channel": "Odaberite kanal.",
    "notifications-send-reason-content": "Upišite sadržaj poruke.",
    "notifications-send-reason-subject": "Upišite predmet e-maila.",
    "notifications-send-reason-reply-to": "Upišite adresu za odgovor ili isključite odgovor na adresu."
};
